export const openChatBot = () => {
    const isBrowser =
        typeof window !== 'undefined' && typeof window.document !== 'undefined';

    if (!isBrowser) return;

    const protocol =
        document.location.protocol === 'https:' ? 'https://' : 'http://';

    const id = '62132ec40d7b5b0007d222c5';
    const src = `${protocol}cdn.chatbot.com/widget/plugin.js`;

    window.__be = window.__be || {};
    window.__be.id = id;
    window.BE_API = window.BE_API || {};

    if (window.BE_API.openChatWindow) {
        if (
            window.BE_API.isChatWindowOpened &&
            !window.BE_API.isChatWindowOpened()
        ) {
            window.BE_API.openChatWindow();
        }
        return;
    }

    window.BE_API.onLoad = () => {
        window.BE_API.openChatWindow();
    };

    if (!isExisting(src)) {
        const scriptEl = document.createElement('script');
        scriptEl.setAttribute('type', 'text/javascript');
        scriptEl.setAttribute('async', true);
        scriptEl.setAttribute('src', src);

        document.body.appendChild(scriptEl);
    }
};

const isExisting = src => {
    return !!document.querySelector(`script[src="${src}"]`);
};
